export const LinkPlaceholder = () => (
  <div className="placeholder-glow my-2">
    <div className="placeholder col-12 rounded" style={{ height: 60, background: '#F1F2F3' }}></div>
  </div>
);

export const PlaceholderList = ({ count = 10 }) => (
  <>
    {[...Array(count)].map((_, index) => (
      <LinkPlaceholder key={index} />
    ))}
  </>
);
